/**
 *
 * AuthenticatedRoute
 *
 */

import React, { useContext } from 'react'; //useContext, //useEffect, //useState,
import { Route, Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { AuthContext } from 'ui/containers/Providers/AuthProvider';
import routeTemplates from 'common/route-templates';
import queryString from 'query-string';

/**
 * @param {element} WrapComponent
 * @param authenticated - a bool base on token provided value from AuthProvider
 *
 * @return
 * render route if authenticated === true else redirect to '/register'
 */
export const AuthenticatedRoute = ({ component: WrapComponent, ...others }) => {
  const { authenticated } = useContext(AuthContext);
  const { location } = others;
  const searchParams = queryString.parse(window.location.search);
  const redirectUrl = searchParams.redirectUrl;
  const redirectPath =
    routeTemplates.login +
    `?redirectUrl=${redirectUrl || encodeURIComponent(location.pathname + location.search)}`;
  return (
    <Route
      {...others}
      render={routeProps =>
        authenticated ? <WrapComponent {...routeProps} /> : <Redirect to={redirectPath} />
      }
    />
  );
};

export default compose(withRouter)(AuthenticatedRoute);
